"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
exports.socialLinksVariants = {
    open: {
        transition: { delay: 0.2, staggerChildren: 0.07, delayChildren: 0.2 }
    },
    closed: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 }
    }
};
exports.SocialLinks = styled_components_1["default"](framer_motion_1.motion.ul)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-top: 10px;\n    margin-top: 10px;\n    padding-bottom: 0;\n    margin-bottom: 0;\n\n    a {\n        color: hsla(0,0%,100%,.7);\n        cursor: pointer;\n        margin: 0 1rem 0 0;\n\n        svg {\n            width: 27px;\n            height: 27px;\n        }\n        &:hover {\n            color: #b4a689;\n        }\n    }\n"], ["\n    padding-top: 10px;\n    margin-top: 10px;\n    padding-bottom: 0;\n    margin-bottom: 0;\n\n    a {\n        color: hsla(0,0%,100%,.7);\n        cursor: pointer;\n        margin: 0 1rem 0 0;\n\n        svg {\n            width: 27px;\n            height: 27px;\n        }\n        &:hover {\n            color: #b4a689;\n        }\n    }\n"])));
var templateObject_1;
